function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4647 0.646447C11.2694 0.451184 10.9528 0.451184 10.7576 0.646447L0.987548 10.4165L0.966797 10.4178L0.968007 10.436L0.646447 10.7576C0.552678 10.8513 0.5 10.9785 0.5 11.1111V15C0.5 15.2761 0.723858 15.5 1 15.5H4.88889C5.0215 15.5 5.14867 15.4473 5.24244 15.3536L5.5639 15.0321L5.58228 15.0333L5.58368 15.0123L15.3536 5.24244C15.5488 5.04718 15.5488 4.7306 15.3536 4.53534L11.4647 0.646447ZM1.5 13.0428V11.3845L2.12707 11.3427C2.40425 11.3242 2.63423 11.5542 2.61575 11.8314C2.55702 12.7123 3.28786 13.4431 4.16873 13.3844C4.44592 13.3659 4.67589 13.5959 4.65741 13.8731L4.61562 14.5H2.95717L1.5 13.0428ZM4.10221 12.3866C4.84971 12.3368 5.48917 12.8555 5.62979 13.552L12.4463 6.73544L9.26455 3.55366L2.44793 10.3703C3.14453 10.5108 3.66337 11.1503 3.61353 11.8979C3.59505 12.1751 3.82503 12.4051 4.10221 12.3866ZM9.97166 2.84656L13.1534 6.02834L14.2929 4.88889L11.1111 1.70711L9.97166 2.84656ZM1.5 14.457V14.5H1.54295L1.5 14.457Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pencil.656bb654.svg";
export { SvgComponent as ReactComponent };